// extracted by mini-css-extract-plugin
export default {"root":"n2xrZl","physicalLayout":"LNYNgf","icon":"aTo_UF","visible":"wRGkgf","hidden":"JRUANI"};